export default __webpack_public_path__ + "static/media/python.af4b6d45.svg";